import queryString from "query-string";

export type Route = {
  build: (id: string, query?: unknown) => string;
  label?: string;
  match: string;
  private: boolean;
};

export type MakeRouteOptions = {
  label?: string;
  build?: (id: string) => string;
  private?: boolean;
};

export interface BreadCrumb {
  label: string;
  route?: string;
}

function makeRoute(match: string, option?: MakeRouteOptions): Route {
  return {
    match,
    label: option?.label ?? match.split("/").pop() ?? "-",
    build: option?.build ?? (() => match),
    private: option?.private ?? true,
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function buildUrl(route: string, query?: any) {
  if (query) {
    route = `${route}?${queryString.stringify(query)}`;
  }
  return route;
}

// console.log(
//   `${window.location.origin}${buildUrl("/view-CRecording-viaemail/123", {
//     case: "ApprovalforRecording",
//     Approve: "true",
//     userId: "7315",
//   })}`
// );
  
export const routes = {
  home: makeRoute("/", { label: "home" }),

  // None Auth Route
  login: makeRoute("/login", { label: "login" }),
  register: makeRoute("/auth/register", { label: "Register" }),
  error: makeRoute("/auth/404", { label: "404" }),
  unAuthorized: makeRoute("/unAuthorized", { label: "404" }),
  // resetPassword: makeRoute("/auth/reset-password", { label: "Reset Password" }),
  resetPassword: {
    match: "/auth/reset-password",
    build: (query?: { u?: string }) => buildUrl(`/auth/reset-password`, query),
    label: "reset Password",
  },
 
// Phonebook
  phonebook: makeRoute("/phonebook", { label: "Phonebook" }),
  userticket: makeRoute("/userTicket", { label: "Phonebook" }),
 
  // Auth Route
  forgotPassword: makeRoute("/auth/forgot-password", {
    label: "Forgot Password",
  }),
  changePassword: makeRoute("/auth/change-password", {
    label: "Change Password",
  }),
 
   // Monthly Schedule
    monthlySchedule: makeRoute("/monthlySchedule", { label: "monthlySchedule" }),

  // Holidays
  Holiday: makeRoute("/Holiday", { label: "Holiday" }),
 
  setNewPassword:  {
    match: "/ForgetPassword",
    build: (query?: { u?: string }) =>
      buildUrl(`/ForgetPassword/ `, query),
    label: "Set New Password",
  },
  dashboard: makeRoute("/dashboard", { label: "dashboard" }),
  dashboard2: makeRoute("/dashboards/dashboard2", { label: "Dashboard" }),
  dashboard3: makeRoute("/dashboards/dashboard3", { label: "Dashboard" }),
  // Time & attendance
  attendanceForLunch: makeRoute("/time-attendance/lunch", {
    label: "Time and Attendance",
  }),
  attendanceForBusiness: makeRoute("/time-attendance/business", {
    label: "Time and Attendance",
  }),
  attendanceForPersonalBusiness: makeRoute(
    "/time-attendance/personal-business",
    {
      label: "Time and Attendance",
    }
  ),
  missingPunch: makeRoute("/time-attendance/missing-punch", {
    label: "Missing Punch",
  }),
    gatepass: makeRoute("/time-attendance/gatepass", {
    label: "GatePass",
  }),
    allLeaveGatepass: makeRoute("/time-attendance/all-leave-gatepass", {
    label: "All Leave GatePass",
  }),
  myTimePunchRecords: makeRoute("/time-attendance/punch-records", {
    label: "My Time Punch Records",
  }),
  building: makeRoute("/time-attendance/building", { label: "building" }),
 
    hierarchy: makeRoute("/Hierarchy/", { label: "Hierarchy" }),
    hierarchy2: makeRoute("/Hierarchy2/", { label: "Hierarchy2" }),
    UserTicket: makeRoute("/UserTicket/", { label: "UserTicket" }),
    planylayout: makeRoute("/Planylayout/", { label: "Planylayout" }),
    RecordingRequest: makeRoute("/RecordingRequest/", { label: "RecordingRequest" }),
    Recordinglist: makeRoute("/Recordinglist", { label: "Recordinglist" }),
    RecordingView: makeRoute("/recordingrequest/view/:id", { label: "RecordingView" }),
    RecordingEdit: makeRoute("/recordingrequest/Edit/:id", { label: "RecordingEdit" }),
    VisitorDisplay: makeRoute("/VisitorDisplay/", { label: "VisitorDisplay" }),
    LunchPassDisplay: makeRoute("/LunchPassDisplay/", { label: "LunchPassDisplay" }),
    MaterialPassDisplay: makeRoute("/MaterialPassDisplay/", { label: "MaterialPassDisplay" }),
 
  // EPO
  epoCreate: makeRoute("/epo/create", { label: "Create EPO" }),
  epoEdit: makeRoute("/epo/edit", { label: "Edit EPO" }),
  epoDetail: makeRoute("/epo/detail", { label: "EPO Detail" }),
  epoVote: makeRoute("/epo/vote", { label: "Vote For EPO Detail" }),
  epoList: makeRoute("/epo/list", { label: "EPO List" }),
  epoPayment: makeRoute("/epo/payment", { label: "EPO Payment" }),
  epoSubordinate: makeRoute("/epo/subordinate", { label: "EPO Subordinate" }),
  epoApproval: makeRoute("/epo/approval", { label: "EPO Approval" }),
  epoView: {
    match: "/view-epo/:epoId",
    build: (id: string, query?: { case?: string }) =>
      buildUrl(`/view-epo/${id}`, query),
    label: "view EPO",
    matchSidebar: ([
      { url1: "/view-epo" },
      { url2: "/view-epo" },
      { url3: "/view-epo" },
      { url4: "/view-epo" },
      { url5: "/view-epo" }])
  },
  epoapproval: {
    match: "/view-epo-viaemail/:epoId",
    build: (id: string, query?: { case?: string , isApprove?: string, userid?: string}) =>
      buildUrl(`/view-epoviaemail/${id}`, query),
    label: "Thank You",
  },
  // HRM
  hrInterviewCreate: makeRoute("/hr/interview-create", {
    label: "Interview Cerate",
  }),
  allRecruitee: makeRoute("/hr/all-recruitee", { label: "All Recruitees" }),
  welcomeNewEmpl: makeRoute("/hr/welcome-new-employe", {
    label: "Welcome New Employee",
  }),
  // interviewEvaluationForm: makeRoute("/evaluation-form/:token", {
    //   label: "Interview Evaluation",
    // }),
     interviewEvaluation: makeRoute("/evaluation", {
      label: "Interview Evaluation",
    }),
    interviewEvaluationForm: makeRoute("/evaluation-form", {
      label: "Interview Evaluation",
    }),
    allEvalutionCandidate: makeRoute("/evaluation-form/all-evalution-candidates", { label: "All Recruitees" }),


  EmployeeOfTheMonthNomination: makeRoute(
    "/hr/employee-of-the-month-nomination",
    {
      label: "Employee Of The Month Nomination",
    }
  ),
  editEmployeeOfTheMonthNomination: {
    match: "/hr/employee-of-the-month-nomination/edit/:id",
    build: (id: string) => buildUrl(`/hr/employee-of-the-month-nomination/edit/${id}`),
    label: "Edit EmployeeOfTheMonthNomination",
    matchSidebar: "/hr/employee-of-the-month-nomination/edit"
  },

  allNominee: makeRoute("/hr/all-nominee", {
    label: "All Nominee",
  }),
  nomineeView: {
    match: "/hr/nominee-view/:id",
    build: (id: string) => buildUrl(`/hr/nominee-view/${id}`),
    label: "View nominee",
    matchSidebar: "/hr/nominee-view"
  },

  allGatePass: makeRoute("/hr/all-gate-pass", {
    label: "ALl Gate Pass",
  }),
  addGatePass: makeRoute("/hr/add-gate-pass", {
    label: "Add Gate Pass",
  }),
  gatePassView: {
    match: "/hr/gate-pass-view/:id",
    build: (id: string) => buildUrl(`/hr/gate-pass-view/${id}`),
    label: "View GatePass",
    matchSidebar: "/hr/gate-pass-view"
  },

  addLetsKnowEachOtherDetails: makeRoute(
    "/hr/add-lets-know-each-other-details",
    {
      label: "Add Lets Know Each Other Details",
    }
  ),
  updateLetsKnowEachOtherDetails: makeRoute(
    "/hr/edit-lets-know-each-other-details/:id",
    {
      label: "Update Lets Know Each Other Details",
      build: (id: string) => buildUrl(`/hr/edit-lets-know-each-other-details/${id}`),
    }
  ),
  allLetsKnowEachOtherDetails: makeRoute(
    "/hr/all-lets-know-each-other-details",
    {
      label: "All Lets Know Each Other Details",
    }
  ),

  
  letsKnowEachotherDetailsView: {
    match: "/hr/lets-know-each-other-details-view/:id",
    build: (id: string) =>
      buildUrl(`/hr/lets-know-each-other-details-view/${id}`),
    label: "View Let's Know Each Other Details",
    matchSidebar: "/hr/lets-know-each-other-details-view"
  },

  addLeaveSheet: makeRoute("/hr/leave-sheet", { label: "Leave Sheet" }),
  allLeaveSheet: makeRoute("/hr/all-leave-sheet", { label: "All Leave Sheet" }),
  viewLeaveSheet: {
    match: "/hr/leave-sheet-view/:id",
    build: (id: string) => buildUrl(`/hr/leave-sheet-view/${id}`),
    label: "View Leave Sheet",
    matchSidebar: "/hr/leave-sheet-view"
  },

  addTrainingSheetForm: makeRoute("/hr/training-module", {
    label: "Training Module",
  }),
  allTrainingList: makeRoute("/hr/training-list", { label: "Training" }),
  viewTraining: {
    match: "/hr/training-details-view/:id",
    build: (id: string) => buildUrl(`/hr/training-details-view/${id}`),
    label: "Training Details View",
    matchSidebar: "/hr/training-details-view"
  },
  editTraining: {
    match: "/hr/training/edit/:id",
    build: (id: string) => buildUrl(`/hr/training/edit/${id}`),
    label: "Edit Training",
    matchSidebar: "/hr/training/edit"
  },

  emailForTraining: makeRoute("/hr/email-for-training", {
    label: "Email For Training",
  }),

  addCourseForm: makeRoute("/hr/course-form", {
    label: "Course Form",
  }),
  allCourseList: makeRoute("/hr/course-List", {
    label: "Course List",
  }),
  viewCourseDetails: {
    match: "/hr/course-details-view/:id",
    build: (id: string) => buildUrl(`/hr/course-details-view/${id}`),
    label: "Course Details View",
    matchSidebar: "/hr/course-details-view"
  },
  addQuestion: makeRoute("/hr/add-question", {
    label: "Add Question",
  }),
  allQuestionlist: makeRoute("/hr/all-question", {
    label: "Add Question",
  }),
  questionView: {
    match: "/hr/question-view/:id",
    build: (id: string) => buildUrl(`/hr/question-view/${id}`),
    label: "view question",
    matchSidebar: "/admin/question-view"
  },
  editQuestion: {
    match: "/hr/edit/:id",
    build: (id: string) => buildUrl(`/hr/edit/${id}`),
    label: "Edit Question",
    matchSidebar: "/hr/edit"
  },
  addCandidateCV: makeRoute("/hr/add-CV", {
    label: "Add CV",
  }),
  getCandidateCV: makeRoute("/hr/all-CV", {
    label: "ALL CV",
  }),
  //Attendance-change
  ftoCreate: makeRoute("/attendance-change/create", {
    label: "Submit New FTO Request",
  }),
 
  ftoList: makeRoute("/attendance-change/list", { label: "FTO Schedule list" }),
  ftoReviewYTD: makeRoute("/attendance-change/review-ytd", {
    label: "Review YTD FTO Status",
  }),
  ftoApprove: makeRoute("/attendance-change/fto-approve", {
    label: "Approve FTO",
  }),
  ftoAllDepartment: makeRoute("/attendance-change/all-fto-department", {
    label: "all FTOs of My Department",
  }),
  ftoFutureDepartment: makeRoute("/attendance-change/future-fto-department", {
    label: " Future FTOs of My Department",
  }),
  allCOADepartment: makeRoute("/attendance-change/all-coas-department", {
    label: "all COA's of My Department",
  }),
  futureCOADepartment: makeRoute("/attendance-change/future-coas-department", {
    label: "all Future COA's of My Department",
  }),
  viewFTO: {
    match: "/view-fto/:ftoId",
    build: (id: string, query?: { case?: string }) =>
      buildUrl(`/view-fto/${id}`, query),
    label: "view fto",
  },
  ftoEdit: {
    match: "/attendance-change/edit/:ftoId",
    build: (id: string, query?: { case?: string }) =>
      buildUrl(`/attendance-change/edit/${id}`, query),
    label: "Edit FTO Request",
  },
  // ftoEdit: makeRoute("/attendance-change/edit/:ftoId", {
  //   label: "Edit FTO Request",
  // }),
  ftoHrApprove: makeRoute("/attendance-change/hr-fto-approve", {
    label: "hr fto approval",
  }),
  // emailviewFTO: {
  //   match: "/view-fto-viaemail/:ftoId",
  //   build: (id: string, query?: { case?: string , email?: string, userId?: string}) =>
  //     buildUrl(`/view-fto/${id}`, query),
  //   label: "view fto",
  // },
  addvisitor: makeRoute("/attendance-change/add-visitor", {
    label: "add visitor",
  }),
  allvisitorlist: makeRoute("/attendance-change/all-visitor", {
    label: "all visitor",
  }),
  addvisitorwithoutlogin: makeRoute("/attendance-change/visitor", {
    label: "add visitor",
  }),
  visitorView: {
    match: "/attendance-change/visitor-view/:id",
    build: (id: string) => buildUrl(`/attendance-change/visitor-view/${id}`),
    label: "view visitor",
    matchSidebar: "/attendance-change/visitor-view"
  },
  editVisitor :{
    match: "/attendance-change/visitor-edit/:id",
    build: (id: string) => buildUrl(`/attendance-change/visitor-edit/${id}`),
    label: "Edit Visitor",
    matchSidebar: "attendance-change/visitor-edit"
  },
  thankyou: {
    match: "/view-fto-viaemail/:ftoId",
    build: (id: string, query?: { case?: string , Approve?: string, userId?: string}) =>
      buildUrl(`/view-fto/${id}`, query),
    label: "Thank You",
  },
cancellationthankyou: {
  match: "/cancel-fto-viaemail/:ftoId",
  build: (id: string, query?: { case?: string; Approve?: string; userId?: string }) =>
    buildUrl(`/cancel-fto-viaemail/${id}`, query),
  label: "Thank You",
},
  //Document Management System
  allDocuments: makeRoute("/document-management/list", {
    label: "all Documents",
  }),
  createECN: makeRoute("/document-management/ecn-create", {
    label: "Create new ECN",
  }),

  createFCD: makeRoute("/document-management/fcd-create", {
    label: "Create new FCD",
  }),
  createLIT: makeRoute("/document-management/lit-create", {
    label: "Create new LIT",
  }),
  createSOP: makeRoute("/document-management/sop-create", {
    label: "Create new SOP",
  }),
  createWI: makeRoute("/document-management/wi-create", {
    label: "Create new WI",
  }),
  documentMyApproval: makeRoute("/document-management/document-approval", {
    label: "Document awaiting my Approval",
  }),
  viewDocument: {
    match: "/document-management/view-document/:documentId",
    build: (
      id: string,
      query?: { documentType?: string; case?: string; documentId?: string }
    ) => buildUrl(`/document-management/view-document/${id}`, query),
    label: "view document",
  },
  editDocument: {
    match: "/document-management/edit-document/:documentId",
    build: (id: string, query?: { case?: string }) =>
      buildUrl(`/document-management/edit-document/${id}`, query),
    label: "edit document",
  },

  // Admin
  addEmployee: makeRoute("/admin/add", { label: "Add Employee" }),
  editEmployee: {
    match: "/admin/edit/:id",
    build: (id: string) => buildUrl(`/admin/edit/${id}`),
    label: "Edit Employee",
    matchSidebar: "/admin/edit"
  },

  limitEmployee: makeRoute("/admin/limit", { label: "Employee Limit" }),
  approvalDocument: makeRoute("/admin/approval", {
    label: "Approval Document Person",
  }),
  roleRights: makeRoute("/admin/role-rights", {
    label: "role and Rights  section",
  }),
  employeeView: {
    match: "/admin/employee-view/:id",
    build: (id: string) => buildUrl(`/admin/employee-view/${id}`),
    label: "view document",
    matchSidebar: "/admin/employee-view"
  },

  // CR
  crCreate: makeRoute("/cr/create", { label: "Create CR" }),
  editCR: {
    match: "/cr/edit/:id",
    build: (id: string) => buildUrl(`/cr/edit/${id}`),
    label: "Edit Change Request",
    matchSidebar: "/cr/edit"
  },
  allChangeRequest: makeRoute("/cr/all-change-request", {
    label: "All Change Request",
  }),
  crView: {
    match: "/cr/cr-view/:id",
    build: (id: string) => buildUrl(`/cr/cr-view/${id}`),
    label: "View Change Request",
    matchSidebar: "/cr/cr-view"
  },

  // Theme URL
  customerList: makeRoute("/customers/lists", { label: "Customers Lists" }),
  customerEdit: makeRoute("/customers/edit", { label: "Edit Customers" }),
  chats: makeRoute("/chats", { label: "Chats" }),
  notes: makeRoute("/notes", { label: "Notes" }),
  email: makeRoute("/email", { label: "Email" }),
  shopList: makeRoute("/shop/lists", { label: "Shop List" }),
  shopDetail: makeRoute("/shop/shop-detail", { label: "Shop Detail" }),
  calendar: makeRoute("/calendar", { label: "Calendar" }),
  tableBasic: makeRoute("/tables/basic-table", { label: "Basic Table" }),
  tablePagination: makeRoute("/tables/pagination-table", {
    label: "Pagination Table",
  }),
  tableEnhanced: makeRoute("/tables/enhanced-table", {
    label: "Enhanced Table",
  }),
  tableCollapsible: makeRoute("/tables/collapsible-table", {
    label: "Collapsible Table",
  }),
  tableFixedHeader: makeRoute("/tables/fixed-header-table", {
    label: "Fixed Header Table",
  }),
  formLayout: makeRoute("/form-layouts/form-layouts", {
    label: "Form Layouts",
  }),
  formWizard: makeRoute("/form-layouts/form-wizard", { label: "Form wizard" }),
  formCustom: makeRoute("/form-layouts/form-custom", { label: "Form Custom" }),
  formAutocomplete: makeRoute("/form-elements/autocomplete", {
    label: "Form Autocomplete",
  }),
  formButton: makeRoute("/form-elements/button", { label: "Form Button" }),
  formCheckbox: makeRoute("/form-elements/checkbox", {
    label: "Form Checkbox",
  }),
  formDateTime: makeRoute("/form-elements/date-time", {
    label: "Form Date-Time",
  }),
  formRadio: makeRoute("/form-elements/radio", { label: "Form Radio" }),
  formSlider: makeRoute("/form-elements/slider", { label: "Form Slider" }),
  formSwitch: makeRoute("/form-elements/switch", { label: "Form Switch" }),
  widgetsFeed: makeRoute("/widgets/widget-feed", { label: "Widgets Feed" }),
  widgetsApps: makeRoute("/widgets/widget-apps", { label: "Widgets Apps" }),
  userProfile: makeRoute("/user-profile", { label: "User Profile" }),
  lineChart: makeRoute("/charts/line-chart", { label: "Line Chart" }),
  gradientChart: makeRoute("/charts/gredient-chart", {
    label: "Gradient Chart",
  }),
  doughnutPieChart: makeRoute("/charts/doughnut-pie-chart", {
    label: "Doughnut Pie Chart",
  }),
  areaChart: makeRoute("/charts/area-chart", { label: "Area Chart" }),
  columnChart: makeRoute("/charts/column-chart", { label: "Column Chart" }),
  candlestickChart: makeRoute("/charts/candlestick-chart", {
    label: "Candlestick Chart",
  }),
  radialBarChart: makeRoute("/charts/radialbar-chart", {
    label: "Radialbar Chart",
  }),
  reactIcons: makeRoute("/react-icons", { label: "React Icons" }),
  quillEditor: makeRoute("/quill-editor", { label: "Quill Editor" }),
  treeView: makeRoute("/treeview", { label: "Treeview" }),
  pricing: makeRoute("/pricing", { label: "Pricing" }),
  timeline: makeRoute("/timeline", { label: "Timeline" }),
  typography: makeRoute("/typography", { label: "Typography" }),
  alert: makeRoute("/alert", { label: "Alert" }),
  limitEmployees: makeRoute("/hr/limit", { label: "Employee Limit" }),
  approvalDocuments: makeRoute("/hr/approval", {
    label: "Approval Document Person",
  }),
  addemployee: makeRoute("/hr/add", { label: "Add Employee" }),
  visitorapproval: {
    match: "/view-Visitor-viaemail/:id",
    build: (id: string, query?: { case?: string , Approve?: string, userId?: string}) =>
      buildUrl(`/view-Visitor-viaemail/${id}`, query),
    label: "Thank You",
  },
    camerarecordingapproval: {
    match: "/view-CRecording-viaemail/:id",
    build: (id: string, query?: { case?: string , Approve?: string, userId?: string}) =>
      buildUrl(`/view-CRecording-viaemail/${id}`, query),
    label: "Thank You",
  },
};
